import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import Checkbox from './Checkbox';

function buildLegalHref(path, hash, returnTo) {
  const query = returnTo ? `?returnTo=${encodeURIComponent(returnTo)}` : '';
  return `${path}${query}${hash}`;
}

function TermsAgreementCheckbox({
  checked,
  onChange,
  id = 'terms-agreement',
  className = '',
  returnTo = '',
}) {
  const { t } = useLanguage();
  const termsHref = buildLegalHref('/terms', '#terms-of-service', returnTo);
  const privacyHref = buildLegalHref('/privacy', '#privacy-policy', returnTo);

  return (
    <div className={`flex items-start gap-3 text-xs leading-snug text-secondary-600  sm:text-sm ${className}`}>
      <Checkbox
        id={id}
        checked={checked}
        onChange={onChange}
        aria-label={`${t.legal.termsLink} ${t.legal.agreementAnd} ${t.legal.privacyLink}`}
      />
      <span>
        {t.legal.agreementPrefix}{' '}
        <a
          href={termsHref}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-orange-600 underline decoration-orange-300 underline-offset-2 hover:text-orange-700 "
        >
          {t.legal.termsLink}
        </a>{' '}
        {t.legal.agreementAnd}{' '}
        <a
          href={privacyHref}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-orange-600 underline decoration-orange-300 underline-offset-2 hover:text-orange-700 "
        >
          {t.legal.privacyLink}
        </a>
      </span>
    </div>
  );
}

export default TermsAgreementCheckbox;
